import React from 'react';
import { connect } from 'react-redux';

import * as paymentsActions from '../../redux/payments/actions';
import submitForm from '../../utils/submitForm';

import Spin from '../../components/loading';
import AlertAndConfirmation from '../../utils/AlertAndConfirmation';
import PaymentsTable from './paymentsTable';
import PaymentsFilter from './paymentsFilter';
import Pagination2 from '../../components/Pagination2';

class Payments extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 1,
      sortType: 'asc',
      sortBy: 'createdAt',
      errorText: locales('errors.default'),
      errorFlag: false,
      itemsPerPage: 10,
      ref: React.createRef()
    };
  }

  componentDidMount() {
    this.sortTable(this.state.sortBy);
  }

  handleAlert = () => {
    AlertAndConfirmation({ text: this.state.errorText, type: 'error' });
    this.setState({ errorFlag: false });
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;

    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllPayments(query);
    });
  };

  applyFilters = event => {
    const queryString = submitForm(event, this.state.selectedRegions, this.state.selectedAmenities);
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllPayments(searchQuery);
    });
  };

  sortTable = query => {
    this.setState({ sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' }, () => {
      query = `${query}-${this.state.sortType}`;
      this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
    });
  };

  exportExcel = e => {
    e.preventDefault();

    const query = this.state.query || 'sort=createdAt-desc';

    this.props.getPaymentsExcelFile(query).then(res => {
      const { filename, blob } = res;

      var ref = this.state.ref;
      ref.current.href = URL.createObjectURL(blob);
      ref.current.download = filename;

      ref.current.click();
    });
  };

  render() {
    let { totalRecords } = this.props.payments;
    let { currentPage, itemsPerPage, sortType } = this.state;

    let loading = this.props.loading || this.props.getPaymentsExcelFileLoading;
    let failed = this.props.failed || this.props.getPaymentsExcelFileFailed;
    let error = this.props.error || this.props.getPaymentsExcelFileError;
    let { message } = this.props;

    return (
      <Spin spinning={loading}>
        <section className="page-header">
          <h1>{locales('titles.paymentsManagement')}</h1>
          <div className="form-actions">
            <a style={{ display: 'none' }} href="empty" ref={this.state.ref}>
              ref
            </a>
            <button className="btn btn-success" onClick={this.exportExcel}>
              <i className="fal fa-file-excel mx-1" />
              {locales('labels.excel.output')}
            </button>
          </div>
        </section>

        {this.state.errorFlag && this.handleAlert()}

        <section className="panel panel-default">
          {error ? (
            <div className="alert alert-danger">{locales('messages.server.error')}</div>
          ) : (
            <>
              {failed && <div className="alert alert-danger">{message}</div>}

              <div className="panel-heading">
                <i className="fas fa-list-alt px-1" />
                {locales('titles.paymentList')}
              </div>

              <div className="panel-body">
                <PaymentsFilter applyFilters={this.applyFilters} filterAndSort={this.filterAndSort} />

                <PaymentsTable
                  pageNumber={currentPage}
                  pageSize={itemsPerPage}
                  sortType={sortType}
                  sortTable={this.sortTable}
                />

                <footer className="col-12 d-flex justify-content-center py-2">
                  <div className="pagination-container">
                    <Pagination2
                      totalRecords={totalRecords || 0}
                      pageLimit={itemsPerPage}
                      pageNeighbours={2}
                      onPageChanged={this.onPageChanged}
                      currentPage={this.state.currentPage}
                    />
                  </div>
                </footer>
              </div>
            </>
          )}
        </section>
      </Spin>
    );
  }
}

const mapStateToProps = state => {
  return {
    paymentsList: state.paymentsReducer.paymentsList,
    payments: state.paymentsReducer.payments || {},
    loading: state.paymentsReducer.loading,
    message: state.paymentsReducer.message,
    failed: state.paymentsReducer.failed,
    error: state.paymentsReducer.error,

    getPaymentsExcelFileLoading: state.paymentsReducer.getPaymentsExcelFileLoading,
    getPaymentsExcelFileFailed: state.paymentsReducer.getPaymentsExcelFileFailed,
    getPaymentsExcelFileError: state.paymentsReducer.getPaymentsExcelFileError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllPayments: query => dispatch(paymentsActions.fetchAllPayments(query)),
    getPaymentsExcelFile: query => dispatch(paymentsActions.getPaymentsExcelFile(query))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Payments);
